import '../../sass/plugins/services_contact_form.scss';
import { initializeForm } from '../utils/form';
import { initializeRecaptcha } from '../utils/recaptcha';
import {
  validateIsTrue,
  validateEmail,
  validateNotEmpty,
} from '../utils/validators';

$(() => {
  const servicesForm = $('#services-form');
  const policyAcceptInput = servicesForm.find('input[name="privacy-policy"]');

  const onPolicyAcceptChange = ($event) => {
    const { checked } = $event.target;
    policyAcceptInput.val(checked);
  };

  initializeRecaptcha();

  initializeForm(servicesForm, {
    validate: (values) => {
      const errors = {
        ...validateIsTrue(values, ['privacy-policy']),
        ...validateNotEmpty(values, [
          'country',
          'name',
          'email',
          'phone',
          'phone_code',
          'service_type',
          'property_type',
        ]),
        ...validateEmail(values),
      };

      const hasErrors = !$.isEmptyObject(errors);
      servicesForm.find('input[type="submit"]').attr('disabled', hasErrors);
      return errors;
    },
  });

  policyAcceptInput.on('click', onPolicyAcceptChange);
});
